import { Model } from '@vuex-orm/core'
import Questionnaire from "./Questionnaire";
import User from "./User";

export default class NewsTeam extends Model {
    // This is the name used as module name of the Vuex Store.
    static entity = 'team'

    static primaryKey = '_id'

    // List of all fields (schema) of the model. `this.attr` is used for the generic field type.
    // The argument is the default value.
    static fields () {
        return {
            _id: this.attr(null),
            title: this.attr(''),
            owner: this.attr({}),
            visibility: this.attr('')
        }
    }

    static apiConfig = {}
}

export class TeamProfile extends NewsTeam {
    static entity = 'team_profile'

    static fields () {
        return {
            ...super.fields(),
            leaders: this.hasMany(Leader, '_id'),
            members: this.hasMany(Member, '_id'),
            tags: this.attr([]),
            questionnaires: this.hasMany(Questionnaire, '_id'),
            childTeams: this.attr([])
        }
    }
}
